import { useLocation, useResolvedPath } from 'react-router-dom';

const useCurrentTab = () => {
  const currentPath = useResolvedPath('..');
  const location = useLocation();

  return location.pathname.replace(currentPath.pathname, '').split('/')[1] ?? '';
};

export default useCurrentTab;
